var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 10.375V4.75h-6.563c-.78.04-1.445.313-1.992.82-.508.547-.78 1.211-.82 1.992v16.875c.04.782.313 1.446.82 1.993.547.508 1.211.78 1.992.82h11.25c.782-.04 1.446-.313 1.993-.82.508-.547.78-1.211.82-1.992V12.25h-5.566c-.547 0-.997-.176-1.348-.527-.39-.352-.586-.801-.586-1.348m1.875-5.625v5.625H35zM16.25 25.375V12.25H7.812c-.78.04-1.445.313-1.992.82-.508.547-.78 1.211-.82 1.992v16.876c.04.78.313 1.445.82 1.992.547.508 1.211.78 1.992.82h11.25c.782-.04 1.446-.313 1.993-.82.508-.547.78-1.211.82-1.992v-2.813H20c-1.055-.04-1.934-.41-2.637-1.113q-1.0545-1.0545-1.113-2.637"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy.ed74e7fc7ac76e2690dd0554a6197962.svg";